import React from "react";
import AccessDenied from "../pages/access-denied";
import Home from "../pages/home";

const LabInventory = React.lazy(() => import("../pages/lab-inventory/lab-inventory-list/index"));
const CheckOutSummary = React.lazy(() => import("../pages/lab-inventory/checkout-summary/index"));
const HWReport = React.lazy(() => import("../pages/tools/hw-report/index"));
const LabInventoryDetails = React.lazy(() => import("../pages/lab-inventory/details/index"));
const LabInventoryAddEdit = React.lazy(() => import("../pages/lab-inventory/lab-inventory-add-edit"));
const LeaseInactiveItems = React.lazy(() => import("../pages/lab-inventory/lab-inventory-lease-inactive-items"));
const LabInventoryReport = React.lazy(() => import("../pages/powerBI/inventory-report"));
const BaaSRaaSReport = React.lazy(() => import("../pages/powerBI/baas-raas-report"));
const LabInventoryAudit = React.lazy(() => import("../pages/lab-inventory-audit/lab-inventory-info-audit"));
const LabInventoryLeaseAudit = React.lazy(() => import("../pages/lab-inventory-audit/lab-inventory-lease-audit"))
const RackAudit = React.lazy(() => import("../pages/rackAudit"));
const Import = React.lazy(() => import("../pages/admin/import"));
const InventoryCategory = React.lazy(() => import("../pages/admin/inventory-category/list"));
const InventoryProject = React.lazy(() => import("../pages/admin/inventory-project/list"));
const InventoryType = React.lazy(() => import("../pages/admin/inventory-type/list"));
const InventoryBundle = React.lazy(() => import("../pages/admin/inventory-bundle/list"));
const PowerLimit = React.lazy(() => import("../pages/admin/powerlimit/list"));
const InventoryStatus = React.lazy(() => import("../pages/admin/inventory-status/list"));
const SecurityGroup = React.lazy(() => import("../pages/admin/security-groups/list"));
const UserActivity = React.lazy(() => import("../pages/admin/user-activity"));
const LeaseHistory = React.lazy(() => import("../pages/lab-inventory/lab-inventory-lease-history/index"));
const SWLicensesPacakges = React.lazy(() => import("../pages/admin/sw-licenses-packages/list/index"));
const ServiceContract = React.lazy(() => import("../pages/admin/service-contract/list/index"));
const ServiceContractAddEdit = React.lazy(() => import("../pages/admin/service-contract/add-edit/index"));
const Site = React.lazy(
    () => import("../pages/admin/site/list")
);
const Building = React.lazy(
    () => import("../pages/admin/building/list")
);
const ManufacturerName = React.lazy(
    () => import("../pages/admin/manufacturername/list")
);
const ChassisManager = React.lazy(() => import("../pages/lab-hw/chassis-manager/list"));
const ChassisManagerAddEdit = React.lazy(() => import("../pages/lab-hw/chassis-manager/add-edit"));
const Corsica = React.lazy(() => import("../pages/machines/corsica/list/index"));
const InfraDevice = React.lazy(() => import("../pages/lab-hw/infra-device/list"));
const IPAddressManagement = React.lazy(() => import("../pages/lab-hw/infra-device/list"));
const InfraDeviceAddEdit = React.lazy(() => import("../pages/lab-hw/infra-device/add-edit"));
const InfraDeviceDetails = React.lazy(() => import("../pages/lab-hw/infra-device/details"));
const Blade = React.lazy(() => import("../pages/lab-hw/blade/list"));
const BladeDetails = React.lazy(() => import("../pages/lab-hw/blade/details/index"));
const Loglist = React.lazy(() => import("../pages/lab-hw/blade/details/logList"));
const PowerInfo = React.lazy(() => import("../pages/lab-hw/blade/details/powerInfo"));
const CurrentPower = React.lazy(() => import("../pages/lab-hw/blade/details/currentPower"));
const TemperatureInfo = React.lazy(() => import("../pages/lab-hw/blade/details/temperatureInfo"));
const CurrentTemperature = React.lazy(() => import("../pages/lab-hw/blade/details/currentTemperature"));
const Jbod = React.lazy(() => import("../pages/lab-hw/jbod/list"));
const JbodLog = React.lazy(() => import("../pages/lab-hw/jbod/jbodlog"));
const PDU = React.lazy(() => import("../pages/lab-hw/pdu/list"));
const Power = React.lazy(() => import("../pages/lab-hw/power/list"));
const PowerDetails = React.lazy(() => import("../pages/lab-hw/power/details"));
const Rack = React.lazy(() => import("../pages/lab-hw/rack/list"));
const RackDetails = React.lazy(() => import("../pages/lab-hw/rack/details"));
const PowerThermal = React.lazy(() => import("../pages/lab-hw/power/monthlyPowerDetails"));
const RackManager = React.lazy(() => import("../pages/lab-hw/rack-manager/list"));
const Dimms = React.lazy(() => import("../pages/blade-hw/dimms/list"));
const DimmsDetails = React.lazy(() => import("../pages/blade-hw/dimms/details"));
const Disks = React.lazy(() => import("../pages/blade-hw/disks/list"));
const DisksDetails = React.lazy(() => import("../pages/blade-hw/disks/details"));
const Nics = React.lazy(() => import("../pages/blade-hw/nics/list"));
const NicsDetails = React.lazy(() => import("../pages/blade-hw/nics/details"));
const Procs = React.lazy(() => import("../pages/blade-hw/procs/list"));
const ProcsDetails = React.lazy(() => import("../pages/blade-hw/procs/details"));
const Fpgas = React.lazy(() => import("../pages/blade-hw/fpgas/list"));
const FpgasDetails = React.lazy(() => import("../pages/blade-hw/fpgas/details"));
const Tpms = React.lazy(() => import("../pages/blade-hw/tpms/list"));
const TpmsDetails = React.lazy(() => import("../pages/blade-hw/tpms/details"));
const BAASRAASReservationRequests = React.lazy(() => import("../pages/baas-raas/reservation-requests/list"));
const BAASRAASReservationRequestsAddEdit = React.lazy(() => import("../pages/baas-raas/reservation-requests/add-edit"));
const dataCenterDetails = React.lazy(() => import("../pages/datacenter/list"));
const dataCenterDetailspage = React.lazy(() => import("../pages/datacenter/details"));
const AllLeases = React.lazy(() => import("../pages/machines/all-leases/index"));
const MyLeases = React.lazy(() => import("../pages/machines/my-leases/index"));

const BAASRAASLeaseManagement = React.lazy(
    () => import("../pages/baas-raas/lease-management/list")
);
const BAASRAASBenchReservation = React.lazy(
    () => import("../pages/baas-raas/lease-management/bench-reservation")
);
const Sustaining = React.lazy(
    () => import("../pages/machines/sustaining/list/index")
);
const SustainingAdd = React.lazy(
    () => import("../pages/machines/sustaining/add-edit")
);
const SustainingEdit = React.lazy(
    () => import("../pages/machines/sustaining/add-edit")
);
const RackNotesAdd = React.lazy(
    () => import("../pages/lab-hw/rack/details/rackNotesAdd")
);
const NotesHistory = React.lazy(
    () => import("../pages/lab-hw/rack/details/notesHistory")
);
const User = React.lazy(
    () => import("../pages/admin/user/add-edit")
);



// Ensure that the keys in 'componentMapping' are identical to those in 'config/routes'
export const componentMapping: { [key: string]: React.FC | React.FC<any> } = {
    accessDenied: AccessDenied,
    home: Home,
    labInventory: LabInventory,
    labInventoryReport: LabInventoryReport,
    baasRaasReport: BaaSRaaSReport,
    labInventoryAudit: LabInventoryAudit,
    rackAudit: RackAudit,
    importLabInventoryInfo: Import,
    importRack: Import,
    importSwitch: Import,
    labInventoryBundle: InventoryBundle,
    labInventoryCategory: InventoryCategory,
    labInventoryProject: InventoryProject,
    labInventoryType: InventoryType,
    hwReport: HWReport,
    powerLimit: PowerLimit,
    site: Site,
    building: Building,
    manufacturerName: ManufacturerName,
    securityGroup: SecurityGroup,
    labInventoryStatus: InventoryStatus,
    labInventoryAdd: LabInventoryAddEdit,
    labInventoryEdit: LabInventoryAddEdit,
    leaseHistory: LeaseHistory,
    leaseInactive: LeaseInactiveItems,
    checkoutSummary: CheckOutSummary,
    corsica: Corsica,
    labInventoryDetails: LabInventoryDetails,
    userActivity: UserActivity,
    sWLicensePackage: SWLicensesPacakges,
    serviceContract: ServiceContract,
    serviceContractAdd: ServiceContractAddEdit,
    serviceContractEdit: ServiceContractAddEdit,
    chassisManager: ChassisManager,
    chassisManagerAdd: ChassisManagerAddEdit,
    chassisManagerEdit: ChassisManagerAddEdit,
    infraDevice: InfraDevice,
    infraDeviceDetails: InfraDeviceDetails,
    infraDeviceAdd: InfraDeviceAddEdit,
    infraDeviceEdit: InfraDeviceAddEdit,
    blade: Blade,
    bladeDetails: BladeDetails,
    jbod: Jbod,
    jbodLog: JbodLog,
    pdu: PDU,
    power: Power,
    rack: Rack,
    rackDetails: RackDetails,
    powerThermal: PowerThermal,
    rackManager: RackManager,
    powerDetails: PowerDetails,
    dimms: Dimms,
    dimmsDetails: DimmsDetails,
    disks: Disks,
    disksDetails: DisksDetails,
    nics: Nics,
    nicsDetails: NicsDetails,
    procs: Procs,
    procsDetails: ProcsDetails,
    fpgas: Fpgas,
    fpgasDetails: FpgasDetails,
    tpms: Tpms,
    tpmsDetails: TpmsDetails,
    baasRaasReservationRequests: BAASRAASReservationRequests,
    baasRaasReservationRequestAdd: BAASRAASReservationRequestsAddEdit,
    baasRaasLeaseManagement: BAASRAASLeaseManagement,
    baasRaasBenchReservation: BAASRAASBenchReservation,
    ipAddressManagement: IPAddressManagement,
    datacenter: dataCenterDetails,
    datacenterdetails: dataCenterDetailspage,
    allleases: AllLeases,
    myleases: MyLeases,
    loglist: Loglist,
    sustaining: Sustaining,
    sustainingAdd: SustainingAdd,
    sustainingEdit: SustainingEdit,
    temperatureinfo: TemperatureInfo,
    powerinfo: PowerInfo,
    currentpower: CurrentPower,
    currenttemperature: CurrentTemperature,
    notesHistory: NotesHistory,
    rackNotesAdd: RackNotesAdd,
    user: User,
    labInventoryLeaseAudit: LabInventoryLeaseAudit,
};
